import { getSettings } from '@immediate_media/script-utils';
import { getContext } from './api/context.js';

let settings;

/**
 * Get the global settings.
 *
 * Settings are read from the `pageInfo` to support of the legacy "Fabric 1"
 * pages, and from the api context with a fallback to `adSettings` for
 * our new "Fabric 2" pages.
 */
export const getGlobalSettings = () => {
  if (!settings) {
    settings = getContext() || getSettings(['adSettings', 'pageInfo']);
  }

  return settings;
};
